import { sort_out_arguments } from './getNumberType';
import _isPossibleNumber from './isPossibleNumber_';

/**
 * Checks if a given phone number is possible.
 * Which means it only checks phone number length
 * and doesn't test any regular expressions.
 *
 * Examples:
 *
 * ```js
 * isPossibleNumber('+78005553535', metadata)
 * isPossibleNumber('8005553535', 'RU', metadata)
 * isPossibleNumber('88005553535', 'RU', metadata)
 * isPossibleNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
export default function isPossibleNumber(arg_1, arg_2, arg_3, arg_4) {
  var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
      input = _sort_out_arguments.input,
      options = _sort_out_arguments.options,
      metadata = _sort_out_arguments.metadata;

  return _isPossibleNumber(input, options, metadata);
}
//# sourceMappingURL=isPossibleNumber.js.map